import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });
export { client };

client.interceptors.request.use((config) => {
  const token = localStorage.getItem("onyx_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default client;

export const auth = {
  login: (email, password) => client.post("/auth/login", { email, password }),
  me: () => client.get("/auth/me"),
  logout: () => localStorage.removeItem("onyx_token"),
  saveToken: (t) => localStorage.setItem("onyx_token", t),
  getToken: () => localStorage.getItem("onyx_token"),
};

export const events = {
  list: (filter = "upcoming") => client.get(`/events?filter=${filter}`).then(r => r.data),
  get: (id) => client.get(`/events/${id}`).then(r => r.data),
  create: (data) => client.post("/events", data).then(r => r.data),
  update: (id, data) => client.put(`/events/${id}`, data).then(r => r.data),
  remove: (id) => client.delete(`/events/${id}`),
};

export const floorPlans = {
  list: () => client.get("/floor-plans").then(r => r.data),
  get: (id) => client.get(`/floor-plans/${id}`).then(r => r.data),
  create: (data) => client.post("/floor-plans", data).then(r => r.data),
  update: (id, data) => client.put(`/floor-plans/${id}`, data).then(r => r.data),
  remove: (id) => client.delete(`/floor-plans/${id}`),
};

export const reservations = {
  create: (data) => client.post("/reservations", data).then(r => r.data),
  list: (params = {}) => client.get("/reservations", { params }).then(r => r.data),
  updateStatus: (id, data) => client.patch(`/reservations/${id}`, data).then(r => r.data),
  remove: (id) => client.delete(`/reservations/${id}`),
};

export const menu = {
  list: (category) => client.get("/menu", { params: category ? { category } : {} }).then(r => r.data),
  create: (data) => client.post("/menu", data).then(r => r.data),
  update: (id, data) => client.put(`/menu/${id}`, data).then(r => r.data),
  remove: (id) => client.delete(`/menu/${id}`),
};

export const media = {
  list: (category) => client.get("/media", { params: category ? { category } : {} }).then(r => r.data),
  create: (data) => client.post("/media", data).then(r => r.data),
  remove: (id) => client.delete(`/media/${id}`),
};

export const settings = {
  get: () => client.get("/settings").then(r => r.data),
  update: (data) => client.put("/settings", data).then(r => r.data),
};

export const stats = {
  get: () => client.get("/admin/stats").then(r => r.data),
};

export const careers = {
  positions: (department) => client.get("/careers/positions", { params: department && department !== "all" ? { department } : {} }).then(r => r.data),
  apply: (data) => client.post("/careers/apply", data).then(r => r.data),
  applications: (params = {}) => client.get("/careers/applications", { params }).then(r => r.data),
  updateApplication: (id, data) => client.patch(`/careers/applications/${id}`, data).then(r => r.data),
  removeApplication: (id) => client.delete(`/careers/applications/${id}`),
  createPosition: (data) => client.post("/careers/positions", data).then(r => r.data),
  updatePosition: (id, data) => client.put(`/careers/positions/${id}`, data).then(r => r.data),
  removePosition: (id) => client.delete(`/careers/positions/${id}`),
};

export const blog = {
  list: (params = {}) => client.get("/blog", { params }).then(r => r.data),
  get: (slug) => client.get(`/blog/${slug}`).then(r => r.data),
  create: (data) => client.post("/blog", data).then(r => r.data),
  update: (id, data) => client.put(`/blog/${id}`, data).then(r => r.data),
  remove: (id) => client.delete(`/blog/${id}`),
};
